<template>
  <div class="check-group">
    <el-select v-model="selectValue">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "FormCheckboxGroup",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: String,
  },
  data() {
    return {
      options: [
        { value: "0-50", label: "0-50" },
        { value: "50-100", label: "50-100" },
        { value: "100-200", label: "100-200" },
        {
          value: "more_than_200",
          title: this.language("companyInformation.productSaleCountOptions"),
        },
      ],
    };
  },
  computed: {
    selectValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.emitCheckList(val);
      },
    },
  },
  methods: {
    emitCheckList(val) {
      try {
        this.$emit("change", val);
      } catch (error) {
        console.log("emit fail", error);
      }
    },
  },
};
</script>

<style></style>
